import { lazyOnSupportPaneClose } from 'diagnostics-and-support';
import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import loc from 'owa-localize';
import {
    editorPaneHeader,
    helpPaneHeader,
    tipsPaneHeader,
} from '../components/AppPaneGroup.locstring.json';
import {
    helpBody,
    rolloutOverridesBody,
    tipsBody,
    editorPane,
} from '../components/AppPaneGroup.scss';
import type { AppPaneConfig } from '../types/AppPaneConfig';

import { DictationHelpPane as LazyDictationHelpPane } from 'owa-editor-dictation';
import { DexPaneWrapper as LazyDexPaneWrapper } from 'owa-editor-proofing-dex-pane';
import { HelpPane as HelpPaneBody } from 'owa-app-help-pane';
import { RolloutOverridesPane as LazyRolloutOverridesPane } from 'owa-header-pane';
import { WhatsNewFluentPane as LazyWhatsNewFluentPane } from 'owa-whats-new';
import { lazyDismissGraphicsPane } from 'owa-editor-content-picker';
import { lazyResetAccCheckerPane } from 'owa-editor-acc-checker';

export const appPanesConfiguration: ReadonlyArray<AppPaneConfig> = [
    // Panes that are rendered as part of the AppPaneGroup
    {
        paneId: getDrawerPaneId('editor'),
        getHeaderText: () => loc(editorPaneHeader),
        getChildren: () => <LazyDexPaneWrapper />,
        bodyClassName: editorPane,
    },
    {
        paneId: getDrawerPaneId('rolloutOverrides'),
        getHeaderText: () => 'Rollout Overrides',
        getChildren: () => <LazyRolloutOverridesPane />,
        bodyClassName: rolloutOverridesBody,
    },
    {
        paneId: getDrawerPaneId('tips'),
        getHeaderText: () => loc(tipsPaneHeader),
        getChildren: () => <LazyWhatsNewFluentPane />,
        bodyClassName: tipsBody,
    },
    {
        paneId: getDrawerPaneId('dictationHelp'),
        getHeaderText: () => loc(helpPaneHeader),
        getChildren: () => <LazyDictationHelpPane />,
    },
    {
        paneId: getDrawerPaneId('help'),
        getHeaderText: () => loc(helpPaneHeader),
        getChildren: () => <HelpPaneBody />,
        bodyClassName: helpBody,
    },

    // Standalone panes that are rendered separately
    {
        paneId: getDrawerPaneId('myDay'),
        isStandaloneComponent: true,
    },
    {
        paneId: getDrawerPaneId('addins'),
        isStandaloneComponent: true,
    },
    {
        paneId: getDrawerPaneId('chatCopilot'),
        isStandaloneComponent: true,
    },
    {
        paneId: getDrawerPaneId('feedback'),
        isStandaloneComponent: true,
    },
    {
        paneId: getDrawerPaneId('getDiagnostics'),
        isStandaloneComponent: true,
    },
    {
        paneId: getDrawerPaneId('support'),
        isStandaloneComponent: true,
        onDismiss: () => {
            lazyOnSupportPaneClose.importAndExecute();
        },
    },
    {
        paneId: getDrawerPaneId('accChecker'),
        isStandaloneComponent: true,
        onDismiss: targetWindow => {
            lazyResetAccCheckerPane.importAndExecute(targetWindow || window);
        },
    },
    {
        paneId: getDrawerPaneId('contentPicker'),
        isStandaloneComponent: true,
        onDismiss: targetWindow => {
            lazyDismissGraphicsPane.importAndExecute(targetWindow || window);
        },
    },
] as const;
